import HtmlTrans from 'components/shared/HtmlTrans';
import { LinkText } from 'components/shared/LinkText';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import MethodologyExperience from './charts/MethodologyExperience';
import MethodologyGender from './charts/MethodologyGender';
import MethodologyRoles from './charts/MethodologyRoles';
import {
  StyledChart,
  StyledContainer,
  StyledDesc,
  StyledFooter,
  StyledHeader,
  StyledSection,
  StyledSubsection,
  StyledSubsectionHeader
} from './MethodologySection.styled';

const MethodologySection: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');
  const { locale } = useRouter();

  return (
    <StyledSection>
      <StyledContainer>
        <StyledHeader>
          <div>
            <Heading1 as="h4" editorial alignLeft>
              {t('methodology.title')}
            </Heading1>
            <StyledDesc>{t('methodology.desc')}</StyledDesc>
            <HtmlTrans
              i18nKey={'methodology.desc2'}
              ns={'state-of-the-sector'}
              components={{
                linkLogin: <LinkText href={getAppUrl(APP_URLS.login, locale)} />
              }}
            />
          </div>
        </StyledHeader>
        <StyledSubsection>
          <StyledSubsectionHeader>
            <h5>{t('methodology.experience.title')}</h5>
            <div
              dangerouslySetInnerHTML={{
                __html: t('methodology.experience.desc')
              }}
            ></div>
          </StyledSubsectionHeader>
          <StyledChart>
            <MethodologyExperience />
          </StyledChart>
        </StyledSubsection>
        <StyledSubsection>
          <StyledSubsectionHeader>
            <h5>{t('methodology.roles.title')}</h5>
            <HtmlTrans
              i18nKey={'methodology.roles.desc'}
              ns={'state-of-the-sector'}
              components={{
                linkRoles: <LinkText href={getAppUrl(APP_URLS.roles, locale)} />
              }}
            />
          </StyledSubsectionHeader>
          <StyledChart>
            <MethodologyRoles />
          </StyledChart>
        </StyledSubsection>
        <StyledSubsection>
          <StyledSubsectionHeader>
            <h5>{t('methodology.gender.title')}</h5>
            <div
              dangerouslySetInnerHTML={{
                __html: t('methodology.gender.desc')
              }}
            ></div>
          </StyledSubsectionHeader>
          <StyledChart>
            <MethodologyGender />
          </StyledChart>
        </StyledSubsection>
        <StyledFooter>{t('methodology.tools')}</StyledFooter>
      </StyledContainer>
    </StyledSection>
  );
};

export default MethodologySection;
